import { ChatMessage } from '../../../../teams-call';
import { ChatBubble } from '../model/chat-bubble.model';

import { extractText } from './html-to-text.function';

/* TODO revise. this is mutating and transforming in addition to sorting */
export function sortMessages(
    messages: ChatMessage[],
    msftUserId: string,
): ChatBubble[] {
    return (
        messages
            .map<ChatBubble>((e) => {
                return {
                    ...e,
                    message: extractText(e.message ?? ''),
                    isUser: msftUserId === e.msftUserId,
                    avatar: '', // TODO
                };
            })
            // html is using flex-direction: column-reverse
            .sort(
                (a, b) =>
                    new Date(b.startTime).getTime() -
                    new Date(a.startTime).getTime(),
            )
    );
}
